import React from 'react';
import { VStack, HStack } from 'native-base';
import { Caption } from '~/shared/Typography';
import { useSpringBigStore } from '@springbig/shared';
import { Button } from '~/shared/Theme';

const FooterTemplate = () => {

    const { merchantName } = useSpringBigStore();

    const handleLinkPress = (url: string): void => {

        if (!url) {
            return;
        }

        window.open(url, '_blank');
    };

    return (
        <VStack alignItems={'center'}>
            <Caption
                text={'footerTemplate.message_disclaimer'}
                fontSize={10}
                textAlign={'center'}
            />
            <HStack alignItems={'center'} space={2}>
                <Caption fontSize={10}>
                    { merchantName && `© ${new Date().getFullYear()} ${merchantName}`}
                </Caption>
                <Button
                    text={'footerTemplate.privacy_policy'}
                    fontSize={10}
                    variant={'text'}
                    modifier={'small'}
                    onPress={() => handleLinkPress('https://my.securelinkit.com/privacy')}
                />
                <Caption>|</Caption>
                <Button
                    text={'footerTemplate.terms_conditions'}
                    fontSize={10}
                    variant={'text'}
                    modifier={'small'}
                    onPress={() => handleLinkPress('https://my.securelinkit.com/terms_conditions')}
                />
            </HStack>
        </VStack>
    );
};

export default FooterTemplate;
